import * as React from 'react';
import { Grid, Typography } from '@mui/material';
import { Button, Icon, ThemeTextSize, Transition } from '.';
import AppService, { align, textalign, textsize, transition } from '../services/app.service';

interface Props {
  id?: string;
  label?: string;
  size?: textsize;
  color?: any;
  bgColor?: any;
  textAlign?: textalign;
  font?: string;
  lineHeight?: number;
  bold?: boolean;
  textToHtml?: boolean;
  displayBlock?: boolean;
  icon?: string;
  iconColor?: any;
  iconSize?: textsize;
  iconNoAutoHeight?: boolean;
  iconOnTop?: boolean;
  url?: string;
  transition?: transition;
  transitionParentid?: string;
  transitionTime?: number;
  transitionPlay?: boolean;
  marginTop?: number;
  marginBottom?: number;
  showMore?: number;
  sx?: any;
  childAlign?: align;
  children?: React.ReactNode;
  onClick?: () => void;
}

export const Text: React.FunctionComponent<Props> = (props) => {
  const sxTextToHtml = props.textToHtml && {whiteSpace: 'pre-line', overflow: 'hidden'}
  const maxLength = Math.abs(props.showMore || 0);
  const isMaxLength = props.label && props.label.length > maxLength;
  const isShowMoreButton = props.showMore && props.showMore > 0 && isMaxLength;
  const [label, setLabel] = React.useState(props.label);
  const [isShowMore, setIsShowMore] = React.useState(props.showMore !== 0);
  
  const onClick = () => {
    props.onClick?.();
    AppService.openLink(props.url);
  }
  
  const onClickShowMore = () => {
    setIsShowMore(!isShowMore);
    if (!isShowMore) 
      document.getElementById(props.id || 'Top')?.scrollIntoView(true);
  }

  React.useEffect(() => {
      if (props.label) {
        var label = props.showMore && isShowMore? props.label.substring(0, maxLength) + (isMaxLength? '...' : '') : props.label;
        if (props.textToHtml && props.bold) label = '<b>' + label + '</b>';
        setLabel(label);
      }
  
  }, [isShowMore, props.showMore, props.label])
  
  const child = () => {
    return (
      <Grid id={props.id} container direction={!props.children || props.displayBlock? 'row' : 'column'} alignItems={props.displayBlock? 'center' : ''} justifyContent={props.childAlign || props.textAlign} bgcolor={props.bgColor} sx={props.sx} mt={(props.label || props.icon) && props.marginTop} mb={(props.label || props.icon) && props.marginBottom}>
        <Grid display={props.iconOnTop? '' : 'inline-flex'} alignItems='center' textAlign='center' sx={{cursor: 'pointer', pointerEvents: (props.url || props.onClick? 'auto' : 'none')}} onClick={onClick}>
          {props.icon && <Icon name={props.icon} size={props.iconSize || props.size} color={props.iconColor || props.color} noAutoHeight={props.iconNoAutoHeight} marginRight={!!props.label}/>}
          <Typography component='div' sx={{typography: ThemeTextSize(props.size || 'medium'), fontFamily: props.font, lineHeight: {xs: (props.lineHeight || 1.5) - 0.1, md: props.lineHeight || 1.5}, ...sxTextToHtml, ...props.sx?.text}} color={props.color} textAlign={props.textAlign || 'left'} dangerouslySetInnerHTML={props.textToHtml? { __html: label || ''}: undefined}>
            {props.textToHtml? undefined : props.bold? <b>{label}</b> : label} 
          </Typography>
        </Grid>
        
        {isShowMoreButton &&
          <Button type='outlined' startIcon={isShowMore? 'south' : 'north'} size='supersmall' onClick={onClickShowMore} />
        }
        {props.children}
      </Grid>
    )
  }
  
  return (
    <>
    {
    props.transition?
      <Transition parentId={props.transitionParentid} type={props.transition} addTime={props.transitionTime} play={props.transitionPlay}>
        {child()}
      </Transition>  
    : child()
    }
    </>
  )
}